import ModalSkeleton from "../../components/ModalSkeleton";
import { Col, Row } from "react-bootstrap";
import { useEffect } from "react";
import { LocationIcon, logo } from "../../constant";
import classes from "./CourtManagementDetail.module.css";
import ActiveAndInActiveControl from "../../components/ActiveAndInActiveControl";
import { useState } from "react";
import DotBall from "../../components/DotBall";
import { daysOfWeek } from "../../data";
import { formatNumberWithCommas } from "../../helpers";
import moment from "moment";
// Function to group court timings by start time, end time, and charges
function groupCourtTimings(timings) {
  // Create a map to store the groups
  const groups = new Map();

  // Group by combining start time, end time, and charges as a key
  timings?.forEach((timing) => {
    const key = `${timing.courtStartTime}-${timing.courtEndTime}-${timing.courtCharges}`;

    if (!groups.has(key)) {
      groups.set(key, []);
    }

    groups?.get(key).push(timing);
  });

  // Convert the map to an array of grouped objects
  return Array.from(groups.values());
}

const CourtManagementDetailModal = ({
  court = null,
  show = false,
  setShow = () => {},
  data = null,
  onSubmit = () => {},
}) => {
  const [status, setStatus] = useState("Active");
  console.log("data = = >>", data);
  useEffect(() => {
    if (data?.courtStatusId == 1) {
      setStatus("Active");
    } else {
      setStatus("Maintenance");
    }
  }, [data]);

  const courtMainImage = data?.courtImages?.find(
    (image) => image?.companyImageTypeId == 1
  )?.companyImage;

  const courtThumbnailImage = data?.courtImages?.find(
    (image) => image?.companyImageTypeId == 2
  )?.companyImage;

  const courtPreviewImages = data?.courtImages?.filter(
    (image) => image?.companyImageTypeId == 3
  );

  const menuItems = [
    {
      icon: <DotBall bookingStatus={1} />,
      label: "Active",
      command: () => {
        (async () => {
          const result = await onSubmit({
            courtId: data?.courtId,
            courtStatusId: 1,
          });
          if (result) {
            setStatus("Active");
          }
        })();
      },
    },
    {
      icon: <DotBall bookingStatus={2} />,
      label: "Maintenance",
      command: () => {
        (async () => {
          const result = await onSubmit({
            courtId: data?.courtId,
            courtStatusId: 2,
          });
          if (result) {
            setStatus("Maintenance");
          }
        })();
      },
    },
  ];

  return (
    <ModalSkeleton
      width="715px"
      title="Court Management Detail"
      show={show}
      setShow={setShow}
    >
      <section className={classes.wrapper}>
        <Row className={classes.row}>
          <Col xs={12}>
            <header className={classes.header}>
              <div className={classes.locationWrapper}>
                <LocationIcon className={classes.icon} />
                <span>{data?.location?.locationName}</span>
              </div>
              <ActiveAndInActiveControl
                menuItems={menuItems}
                value={status}
                setter={(e) => {
                  console.log("e change", e);
                  setStatus(e);
                  // onSubmit(e)
                }}
              />
            </header>

            {/* <div className={classes.actionsWrapper}>
              <button>View Payment</button>
              <button>View Booking</button>
            </div> */}
          </Col>
          <Col xs={12} md={6}>
            <Label label={"Thumbnail Image"} />
            <PreviewImage image={courtThumbnailImage} />
          </Col>
          <Col xs={12} md={6}>
            <Label label={"Upload Court Image"} />
            <PreviewImage image={courtMainImage} />
          </Col>
          <Col xs={12}>
            <p className={classes.description}>{data?.courtDescription}</p>
          </Col>
          <Col xs={12}>
            <ul className={classes.previewImages}>
              {courtPreviewImages?.map((image) => (
                <PreviewImage image={image?.companyImage} />
              ))}
            </ul>
          </Col>

          <Col xs={12}>
            <div className={classes.viewBoxWrapper}>
           { groupCourtTimings(data?.courtTimings)?.length>0?
          
          
<>
              {groupCourtTimings(data?.courtTimings).map((timing) => {
                let name = [];

                const t = timing?.forEach((item) => {
                  console.log("item", item);
                  name.push(
                    daysOfWeek.find((day) => day.value === item?.courtDayOfWeek)
                      ?.label + ", ");
                });
                name = [...new Set(name)];
                return (
                  <Row>
                    <Col md={4}>
                      <ViewBox value={name?.join("").slice(0, -2)} label={"Day"} />
                    </Col>
                    <Col md={4}>
                      <ViewBox
                        value={`${moment(
                          `2025-01-01 ${timing?.[0]?.courtStartTime}`
                        ).format("hh:mm A")} - ${moment(
                          `2025-01-01 ${timing?.[0]?.courtEndTime}`
                        ).format("hh:mm A")}`}
                        label={"Time"}
                      />
                    </Col>
                    <Col md={4}>
                      <ViewBox
                        value={formatNumberWithCommas(
                          timing?.[0]?.courtCharges
                        )}
                        label={"Price"}
                      />
                    </Col>
                  </Row>
                );
              })}
              </> :<h3 className={classes.fallback}>No slots are available</h3>
              }
            </div>
          </Col>
        </Row>
      </section>
    </ModalSkeleton>
  );
};

export default CourtManagementDetailModal;
const Label = ({ label, children }) => {
  return (
    <div className={classes.labelWrapper}>
      <h2 className={classes.label}>{label}</h2>
      {children}
    </div>
  );
};
const PreviewImage = ({ image }) => {
  return (
    <div>
      <figure className={classes.figure}>
        <img src={image} alt="court" />
      </figure>
    </div>
  );
};

const ViewBox = ({ value, label = "LABEL" }) => {
  return (
    <>
      <Label label={`${label}:`} />
      <p className={classes.viewBox}>{value}</p>
    </>
  );
};
